

/**
 * Given a Map, create the filter/query criteria
 * Result should conform to the pattern below
 * filter: {
        <lowercase (KEY)>: { eq: <VALUE> }
        and: 
        {agegroup: { eq: FORTIES }
        } 
      }
      !! Filter fields MUST Be of type Enum

 * @param map 
 * @returns 
 */
export function AndEnumFilterGenerator(map){
    let result="filter: {}";
    if (map.size===0){
        return result;
    }
    result = "filter: {"; 
    map.forEach((value, key) => {
        let s="";               
        s = s.concat(key.toLowerCase().concat(":")); // Have age:
        s = s.concat("{ eq:",value,"}");
        result = result.concat(s);
        result = result.concat(",");       
    });
    result =result.concat("}");
    return result;
}

/**
 * Given a Map and a string to search for,create the filter/query criteria
 * Result should conform to the pattern below
 * filter: {
        <lowercase (KEY)>: { eq: <VALUE> }
        and: 
        {agegroup: { eq: FORTIES }
        } 
      }
      !! Filter fields MUST Be of type Enum

 * @param map 
 * @returns 
 */
export function AndEnumFilterGeneratorWithSearch(map, searchString){
    if (searchString === undefined || searchString === null || searchString.length === 0) {
        return AndEnumFilterGenerator(map);
    }
    // If we have a search string, we need to add it to the filter
    // so we will add a "search" field to the filter
    // The search field will be a "contains" type
    // and will be added to the end of the filter, so we need a placeholder for it
    // but or to zap it if the search criteria is empty

    

    let result="filter: {}";
    if (map.size===0){
        return result;
    }
    //result = "filter: {first_name: {contains: \"dan\"},";  -- it is case sensitive
    result = "filter: {"; 
    if (searchString.length > 0) {
        searchString = searchString.toLowerCase();
        result = result.concat("searchstring:");
        result= result.concat("{ contains:\"",searchString,"\"},");
    }

    map.forEach((value, key) => {
        let s="";               
        s = s.concat(key.toLowerCase().concat(":")); 
        s = s.concat("{ eq:",value,"}");
        result = result.concat(s);
        result = result.concat(",");       
    });
    result =result.concat("}");
    return result;
}